import * as React from 'react';
import {Dialog, DialogTitle, TextField, ImageList, WithStyles, withStyles, Popover} from '@material-ui/core';
import {displayErrorMessage} from '@services/user/user.actions';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import {connect} from 'react-redux';
import { addDays } from '@helpers/DateHelper';
import {IFamilyMember} from '@app-types/websocket/family.types';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {FamilyMemberType} from "@services/family/family.constants";
import {IEcoAgreement, IEcoPurchase, IEcoSplit, INewEcoPurchase, IUpdateEcoPurchase, IEcoSplitSetting, EcoRepeat} from "@app-types/websocket/economy.types";
import ImgAvatar from "@components/common/avatar/ImgAvatar";
import DeleteIcon from '@material-ui/icons/DeleteForeverTwoTone';
import CameraIcon from '@material-ui/icons/CameraAltOutlined';
import AddIcon from '@material-ui/icons/Add';
import * as FileActions from '@services/file/file.actions';
import {
  AmountLabel,
  BoxedRow,
  Col,
  CustomDialogContent,
  CustomSelect,
  CustomTextField,
  DialogTop,
  PercentageLabel,
  Row,
  CustomSelectInverted,
  StyledInputAdornment,
  StyledLabel,
  StyledSlider,
  convertSliderValueToPercentage,
  convertPercentageToSliderValue,
  CustomText,
  dialogStyles,
  CustomTextFieldInvertedP,
} from './DialogComponens';
import CustomSwitch from './CustomSwitch';
import { IFileDesc, IStuffBeingUploaded, IFinishedUpload,IUploadFile } from '@app-types/websocket/file.types';
import ListImage from './sharedcomponents/ListImage';
import ChatButton from './ChatButton';
import { ChatType } from '@app-types/websocket/chat.types';
import { getWeekNum } from '@helpers/DateHelper';
import { buttonContainedLarge, primaryColor, styleColors } from 'src/main.style';
import { dataURLToBlob, getCanvasBlobFromImageFile, getCanvasDataURLFromFile, handleBlobUpload, handleImageUpload, fileToBase64 } from '@helpers/uploadHelper';
import AvatarEditor from 'react-avatar-editor';
import { IAnalysedReceipt } from '@app-types/websocket/event.types';
import PinchZoomImage from '@helpers/PinchZoomImage';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof dialogStyles> {
  isOpen: boolean;
  onClose: () => void;
  onCreateNew: (values:INewEcoPurchase) => void;
  onEdit: (values:IUpdateEcoPurchase) => void;
  onDelete: (purchaseId:number) => void;
  onRestore: (purchaseId:number) => void;
  onChallenge: (purchaseId:number) => void;
  userId: number;
  family: IFamilyMember[];
  completedAgreement?: IEcoAgreement;
  existingPurchase?:IEcoPurchase;
  aiPurchase?:IAnalysedReceipt;
  showAgreement: (agreementId:number|undefined) => void;
  settings:IEcoSplitSetting[];
  currency:string;
  displayErrorMessage: (msg: string) => void;

  
  uploadingFiles: IStuffBeingUploaded[];
  uploadedFiles: IFinishedUpload[];
  uploadFile:(file: IUploadFile) => void;
  uploadedFileUsed: (file: number) => void;
  removeStoredFile: (file: number) => void;
  waitForPurchaseChat:(id:number) => void;
}

interface IState {
  hasTouchedTitle:boolean;
  hasTouchedAmount:boolean;
  previousFiles: IFileDesc[];

  values: INewEcoPurchase;

  highlightSubtitle:boolean;

  zoomImage:string|undefined;
  internalImages:number[],
  internalDataUrl:string[];
  loadedImageUrls:string[];
  saveClicked:boolean;
  showSelectPaidBy:boolean;
  currencyDiscrepancy:boolean;
  showMoreDetails:boolean;
}

class PurchaseDialog extends React.Component<IProps, IState> {
  private paidByRef: React.RefObject<HTMLDivElement> = React.createRef();

  private editorRef1: React.RefObject<AvatarEditor> = React.createRef();
  private editorRef2: React.RefObject<AvatarEditor> = React.createRef();
  private editorRef3: React.RefObject<AvatarEditor> = React.createRef();

  constructor(props: IProps) {
    super(props);

    const {existingPurchase, completedAgreement} = props;

    this.state = {
      ...this.newState(existingPurchase,completedAgreement, props.aiPurchase)
    };
  }

  public componentDidUpdate(oldProps:IProps, oldState:IState) {
    if (this.state.saveClicked && this.props.uploadedFiles !== oldProps.uploadedFiles) {
      
      let uploadedFilesCount = 0;
      for (const internalId of this.state.internalImages) {
        if (this.props.uploadedFiles.findIndex((u) => u.internalId === internalId) !== -1) {
          uploadedFilesCount += 1;
        }
      }

      if (uploadedFilesCount === this.state.internalDataUrl.length) {
        this.save();
      } else {
        if (uploadedFilesCount === 1 && this.editorRef2.current) {
          this.upload(this.editorRef2.current, 800,800);
        } else if (uploadedFilesCount === 2 && this.editorRef3.current) { 
          this.upload(this.editorRef3.current, 800,800);
        }
      }
    }
    if (this.props.completedAgreement !== undefined && this.props.completedAgreement !== oldProps.completedAgreement ) {
      if (oldProps.completedAgreement === undefined || oldProps.completedAgreement.id !== this.props.completedAgreement.id) {
        if (this.props.existingPurchase === undefined) {
          this.directSaveClose(this.props.completedAgreement);
        }
      }
    }
    if (this.props.isOpen === true && oldProps.isOpen === false) {
      const {existingPurchase, completedAgreement} = this.props;
      this.setState(this.newState(existingPurchase,completedAgreement, this.props.aiPurchase));
    }
  }

  public newState(existingPurchase:IEcoPurchase|undefined, existingAgreement: IEcoAgreement|undefined, aiPurchase:IAnalysedReceipt|undefined):IState {
    if (existingPurchase) {
      return {
        highlightSubtitle:false,
        hasTouchedTitle:true,
        hasTouchedAmount:true,
        values: {
          agreementId: existingPurchase.agreementId,
          closeAgreement: false,
          title: existingPurchase.title,
          children: existingPurchase.children,
          amount: existingPurchase.amount,
          currency: existingPurchase.currency,
          description: existingPurchase.description,
          images: [],
          date: existingPurchase.date,
          paidBy: existingPurchase.paidBy,
          split: existingPurchase.split,
          startAsDisputed: (existingPurchase.disputedBy !== undefined && existingPurchase.disputedBy > 0),
          fromSharedAccount: existingPurchase.fromSharedAccount,
        },
        previousFiles:existingPurchase.images || [],
        zoomImage:undefined,
        internalImages:[],
        internalDataUrl:[],
        loadedImageUrls:[],
        saveClicked:false,
        showSelectPaidBy:false,
        currencyDiscrepancy:existingPurchase.currency !== this.props.currency,
        showMoreDetails:true,
      };
    } else if (existingAgreement) {
      const newTitle = existingAgreement.repeat === EcoRepeat.ONCE
        ? existingAgreement.title
        : existingAgreement.repeat === EcoRepeat.WEEKLY?
          `${existingAgreement.title} (${tn.lang.getWeekName(getWeekNum(new Date(existingAgreement.forDate)))})`
        : existingAgreement.repeat === EcoRepeat.MONTHLY?
          `${existingAgreement.title} (${tn.lang.getMonthName((new Date(existingAgreement.forDate)).getMonth())})`
        : existingAgreement.repeat === EcoRepeat.QUARTERLY?
          `${existingAgreement.title} (${tn.lang.getQuarterName((new Date(existingAgreement.forDate)))})`
        : existingAgreement.repeat === EcoRepeat.TERM?
          `${existingAgreement.title} (${tn.lang.getTermName((new Date(existingAgreement.forDate)))})`
        :`${existingAgreement.title} (${(new Date(existingAgreement.forDate)).getFullYear()})`;
      return {
        highlightSubtitle:false,
        hasTouchedTitle:true,
        hasTouchedAmount:true,
        
        values: {
          agreementId: existingAgreement.id,
          closeAgreement: true,
          title: newTitle,
          children: existingAgreement.children,
          amount: existingAgreement.amount?existingAgreement.amount:0,
          currency: existingAgreement.currency,
          description: existingAgreement.description,
          images: [], 
          paidBy: this.props.userId,
          split: existingAgreement.split,
          startAsDisputed: false,
          fromSharedAccount: false,
        },
        previousFiles:existingAgreement.images || [],
        zoomImage:undefined,
        internalImages:[],
        internalDataUrl:[],
        loadedImageUrls:[],
        saveClicked:false,
        showSelectPaidBy:false,
        currencyDiscrepancy:existingAgreement.currency !== this.props.currency,
        showMoreDetails:false,
      };
    } else {

      const split = (this.props.settings.length > 0)
        ?(this.props.settings[this.props.settings.length -1].split.map((sp) => ({accountId:sp.accountId, percentage:sp.percentage})))
        :this.props.family.filter(m => m.role === FamilyMemberType.PARENT)
        .map(m => ({
          accountId: m.id,
          percentage: 50,
        }));

      const achild = this.props.family.find(m => m.role === FamilyMemberType.CHILD);

      let title:string = "";
      let description:string = "";
      let amount:number = 0;
      // Always the family currency; a differing AI-detected currency only flags currencyDiscrepancy.
      const currency:string = this.props.currency;
      const images:number[] = [];
      let previousFiles:IFileDesc[] = [];
      let currencyDiscrepancy:boolean = false;
      if (this.props.aiPurchase) {
        if (this.props.aiPurchase.title) {
          title = this.props.aiPurchase.title;
        }
        if (this.props.aiPurchase.description) {
          description = this.props.aiPurchase.description;
        }
        if (this.props.aiPurchase.amount ) {
          const mt = Number.parseInt(this.props.aiPurchase.amount, 10);
          if (Number.isFinite(mt)) {
            amount = mt;
          }
        }
        // The AI result comes over the websocket as JSON, so its fields can be null, not just undefined.
        const { fileId, imageUrl } = this.props.aiPurchase;
        if (typeof fileId === 'number' && typeof imageUrl === 'string') {
          const img:IFileDesc = {
            id: fileId,
            fileName: "receipt.png",
            fileSize: 50000,
            url: imageUrl,
          }
          previousFiles = [img];
        }
        const aiCurrency = this.props.aiPurchase.currency;
        currencyDiscrepancy = typeof aiCurrency === 'string' && aiCurrency.length === 3
          && aiCurrency !== this.props.currency;
      }
      return {
        highlightSubtitle:false,
        hasTouchedTitle: false,
        hasTouchedAmount:false,
        values: {
          title,
          children: (achild?[achild.id]:[]),
          amount,
          currency,
          description,
          images,
          split,
          paidBy: this.props.userId,
          startAsDisputed: false,
          fromSharedAccount: false,
        },
        previousFiles,
        zoomImage:undefined,
        internalImages:[],
        internalDataUrl:[],
        loadedImageUrls:[],
        saveClicked:false,
        showSelectPaidBy:false,
        currencyDiscrepancy,
        showMoreDetails:false,
      };
    }
  }

  public render() {
    const { isOpen, onClose, userId, family,existingPurchase } = this.props;
    const { values } = this.state;

    let myPercentage = 50;
    let coparentName = "Unknown";
    for (const split of values.split) {
      if (split.accountId === this.props.userId) {
        myPercentage = split.percentage;
      } else {
        coparentName = tn.familyMemberName(split.accountId,this.props.family);
      }
    }

    let title = tn.lang.purchaseNew;
    let subtitle:string|undefined;
    if (this.props.existingPurchase !== undefined) {
      title = tn.lang.purchaseEdit;
      subtitle =tn.lang.purchaseEditSubtitle(tn.familyMemberName(this.props.existingPurchase.creator, family));
      if (this.props.existingPurchase.deleted) {
        title = title + " ("+tn.lang.erased+")";
      }
    } else if (this.props.completedAgreement !== undefined) {
      if (this.props.completedAgreement.closed) {
        title = tn.lang.purchaseDoneClosed;
      } else {
        title = tn.lang.purchaseDone;
      }
      
    }
    
    let buttonText = tn.lang.send;
    if (this.state.saveClicked) {
      buttonText = tn.lang.uploading;
    } else if (this.props.existingPurchase !== undefined) {
      buttonText = tn.lang.update;
    } else if (this.props.completedAgreement !== undefined) {
      buttonText = tn.lang.done;
    }

    const deletedPurchase = (this.props.existingPurchase !== undefined && this.props.existingPurchase.deleted)
      ? this.props.existingPurchase : undefined;
    const actionButton = deletedPurchase !== undefined
      ? <Button onClick={() => this.props.onRestore(deletedPurchase.id)} color='primary' variant='contained'
          style={buttonContainedLarge}>
          {tn.lang.ecoRestore}
        </Button>
      : <Button onClick={() => this.handleSubmit()} color='primary' variant='contained' style={buttonContainedLarge} 
      disabled={this.state.saveClicked
        || this.state.internalDataUrl.some(url => !this.state.loadedImageUrls.includes(url))
        || ((values.title.trim().length < 2)
        || values.amount <= 0)}>
          
        {buttonText}
    
      </Button>;

/*
    if (this.props.existingPurchase !== undefined 
      && !this.props.existingPurchase.deleted
      && this.props.existingPurchase.creator !== userId) {
      const pur = this.props.existingPurchase;
      actionButton = <Button color={(this.props.existingPurchase.disputedBy && this.props.existingPurchase.disputedBy > 0)?'primary':'primary'}
        variant='contained' style={buttonContainedLarge} onClick={() => this.props.onChallenge(pur.id)}>
        {(this.props.existingPurchase.disputedBy && this.props.existingPurchase.disputedBy > 0)
          ?tn.lang.approve
          :tn.lang.question}
      </Button>;
    }
*/
    let chatButton:JSX.Element|undefined;
    if (existingPurchase !== undefined && (existingPurchase.chatId !== undefined || existingPurchase.creator !== userId)) {
      const chatTitle = tn.lang.purchaseRegardingTitle(existingPurchase.title);
      chatButton = <ChatButton referenceObject={existingPurchase.id} family={family} chatId={existingPurchase.chatId} 
        chatType={ChatType.PURCHASE_CHAT} callBack={onClose} title = {chatTitle} waitForPurchaseChat={this.props.waitForPurchaseChat}
        msg = {existingPurchase.description?existingPurchase.description:chatTitle}/>;
    }

    let fileUrl = ""; 
    let fileTitle = "";
    if (this.props.existingPurchase !== undefined) {
      fileTitle = this.props.existingPurchase.title;
    }
    if (this.state.zoomImage !== undefined) {
      fileUrl = this.state.zoomImage;  
    }

    const disableEdit = (this.props.existingPurchase !== undefined ); // && this.props.existingPurchase.creator !== userId);
    return (<>
      <Dialog
        open={isOpen}
        onClose={() => {this.cleanup(); onClose();}}
        fullWidth={true}
      >
        <DialogTop >
          <Col style={{flex:1, alignItems: 'center'}}>
            <DialogTitle>{title}</DialogTitle>
            {subtitle && <StyledLabel style={this.state.highlightSubtitle
              ?{marginTop: '-16px', color:styleColors.pureRed,fontWeight: 600, fontSize: '10px'}:{marginTop: '-16px'}}>
              {subtitle}</StyledLabel>}
          </Col>
          <IconButton onClick={() => {this.cleanup(); onClose();}}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <CustomDialogContent style={{position:'relative'}} >
          {/* (this.props.existingPurchase !== undefined && this.props.existingPurchase.creator !== userId) 
            && <div style={{position:'absolute', width:'100%', height:'100%', zIndex:2, top:0, left:0}} 
            onClick={() => this.setState({highlightSubtitle:true})} /> */}
          <Row style={{ alignItems: 'center', gap: '16px', }}>
            <Col style={{ flex: 1 }}>
                <CustomTextField
                  name="title"
                  value={values.title}
                  onBlur={() => this.setState({hasTouchedTitle:true})}
                  style={((this.state.hasTouchedTitle && values.title.trim().length < 2)?{border: `1px solid ${styleColors.coralRed}`}:{})}
                  onChange={this.handleChange}
                  placeholder={tn.lang.title}
                  InputProps={{ disableUnderline: true}}
                  tabIndex={2}
                  autoCorrect={"on"}
                  autoFocus={(values.title.trim().length>0?false:true)}
                  InputLabelProps={{ shrink: false }}
                />
            </Col>
            <Col style={{position:'relative', background: styleColors.greyLight2, borderRadius: '4px'}}>
                <StyledLabel htmlFor="children" style={{position: 'absolute', top: '2px', zIndex:2, left:'2px'}}>
                  {tn.lang.agreementForWho}
                </StyledLabel>
                <CustomSelect
                  name="children"
                  tabIndex={8}
                  value={this.getSelectedChildrenOption(values.children)}
                  displayEmpty={true}
                  onChange={this.handleChildrenChange}
                  disableUnderline={true}
                  data={this.childrenDropdownData()}
                />
            </Col>
          </Row>
          <BoxedRow >
            <Col style={{ flex: 1, alignItems: 'flex-start', justifyContent: 'center', minWidth: 130 }}>
              <StyledLabel htmlFor="amount" style={{fontSize:'10px', lineHeight:'10px'}}>{tn.lang.price}</StyledLabel>
            </Col>
            <Col style={((this.state.hasTouchedAmount && (values.amount === undefined || values.amount <= 0))?
              {border: `1px solid ${styleColors.coralRed}`, borderRadius:'4px'}:{})}>
              <CustomTextFieldInvertedP
                name="amount"
                id="amount"
                value={(values.amount === undefined || values.amount===0)?"":values.amount}
                onBlur={() => this.setState({hasTouchedAmount:true})}
                placeholder={(values.amount === undefined || values.amount===0)?"0":undefined}
                onChange={this.handleChange}
                type="number" 
                inputMode="numeric"
                tabIndex={3}
                autoComplete="off"
                InputProps={{
                  disableUnderline: true,                      
                  endAdornment: (<StyledInputAdornment position="end" style={this.state.currencyDiscrepancy?{color:primaryColor}:{}}
                    disableTypography={true}>{this.props.currency}</StyledInputAdornment>),
                  style:{fontSize:'13px'}
                }}
                InputLabelProps={{ shrink: false, style:{fontSize:'13px'} }}
              />
            </Col>
          </BoxedRow>
          <Col>
            <StyledLabel style={{fontSize:'10px', lineHeight:'10px'}}>
              {tn.lang.agreementSplitQuestion}
            </StyledLabel>
            <Row style={{ justifyContent: 'space-around' }}>
              <Col style={{ alignItems: 'center', minWidth: '33%' }}>
                {(values.amount !== undefined && values.amount > 0) && (
                  <AmountLabel>{tn.formatNumber((values.amount * (100-myPercentage))/100, this.props.currency)}</AmountLabel>
                )}
                <PercentageLabel
                  onClick={() => this.handlePercentageClick('coparent')}
                  style={{color:styleColors.greyDark2, cursor:'pointer', userSelect:'none'}}>
                  {100-myPercentage} %
                </PercentageLabel>
                <StyledLabel style={{margin: '-4px 0px'}}>{tn.lang.agreementCoparentPart(coparentName)}</StyledLabel>
              </Col>
              <Col style={{ alignItems: 'center', minWidth: '33%' }}>
                {(values.amount !== undefined && values.amount > 0) && (
                  <AmountLabel>{tn.formatNumber((values.amount * myPercentage)/100, this.props.currency)}</AmountLabel>
                )}
                <PercentageLabel
                  onClick={() => this.handlePercentageClick('mine')}
                  style={{color:styleColors.greyDark2, cursor:'pointer', userSelect:'none'}}>
                  {myPercentage} %
                </PercentageLabel>
                <StyledLabel style={{margin: '-4px 0px'}}>{tn.lang.agreementMyPartSet}</StyledLabel>
              </Col>
            </Row>
          </Col>
          <Col>
            <StyledSlider
              name="split"
              value={convertPercentageToSliderValue(myPercentage)}
              onChange={this.handleSliderChange}
              min={0}
              max={36}
              step={1}
            />
          </Col>

          {!existingPurchase &&
            <div
              onClick={() => this.setState({showMoreDetails:true})}
              style={{
                alignItems: 'center',
                background: styleColors.white,
                color: styleColors.warmGrey,
                cursor: 'pointer',
                display: 'flex',
                flexShrink: 0,
                fontFamily: 'Metropolis',
                fontSize: '10px',
                fontWeight: 400,
                justifyContent: 'center',
                letterSpacing: '1px',
                lineHeight: '10px',
                maxHeight: this.state.showMoreDetails?'0px':'32px',
                opacity: this.state.showMoreDetails?0:1,
                overflow: 'hidden',
                textTransform: 'uppercase',
                transition: 'max-height 0.3s, opacity 0.2s',
              }}>
              <span>{tn.lang.showMore}</span>
            </div>}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 0,
            gap: '16px',
            maxHeight: this.state.showMoreDetails?'700px':'0px',
            overflow: 'hidden',
            transition: 'max-height 0.35s ease',
          }}>
            <BoxedRow>
              <Col style={{flex:1}}>
                  <TextField
                    name="description"
                    value={values.description}
                    onChange={this.handleChange}
                    multiline={true}
                    placeholder={tn.lang.labelDescription}
                    InputProps={{ disableUnderline: true }}
                    InputLabelProps={{ shrink: false }}
                  />
              </Col>
              {(this.props.uploadingFiles.length + this.props.uploadedFiles.length + this.state.previousFiles.length
              +this.state.internalDataUrl.length) === 0 &&
                <div key={"addT"} style={{minHeight: '30px', minWidth: '40px',
                  display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <label htmlFor="add-file-7" >
                    <input type="file"  multiple={false } style = {{opacity: 0, position: 'absolute', width:'40px', height:'30px'}}
                      id={"add-file-7"} onChange={this.parseFile} accept="capture=camera,image/*"/>
                    <CameraIcon style={{fill:"rgb(155 149 149)"}} />
                  </label>
                </div>}
            </BoxedRow>
            <BoxedRow style={{paddingTop: '16px'}}>
              <StyledLabel style={{position: 'absolute', top: '4px', left: '8px', fontSize:'10px', lineHeight:'10px'}}>
                {tn.lang.ecoPaidBy}
              </StyledLabel>
              <Col style={{flexDirection:'row', alignItems: 'center'}}>
                <CustomText  ref={this.paidByRef} onClick={() => {if(this.state.values.fromSharedAccount) {
                      this.setState((prevState: IState) => ({values: {...prevState.values,fromSharedAccount: false}}))
                    } else {
                      this.setState({showSelectPaidBy:true})
                    }}
                  }
                  style={{backgroundColor: (values.fromSharedAccount?'unset':'white'), cursor: 'pointer',}} >
                  {tn.lang.ecoPrivateAcc}
                  {tn.avatar(family, this.state.values.paidBy, {width:20, height:20})}
                </CustomText>
                <Popover
                  disableScrollLock={true}
                  anchorEl={this.paidByRef.current}
                  onClose={() => this.setState({showSelectPaidBy:false})}
                  open={(this.state.showSelectPaidBy === true)}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                >
                  <div style={{padding:'16px', display:'flex', flexDirection:'column', gap:'16px'}}>
                  {family.filter((mem) => mem.role === FamilyMemberType.PARENT).map((mem) =>
                    <div key={mem.id} onClick={() => this.setState((prevState: IState) =>
                      ({showSelectPaidBy:false, values: {...prevState.values,fromSharedAccount: false, paidBy:mem.id}}))}>
                      <ImgAvatar key={mem.id} color={mem.color} altText={mem.firstName} imgName={mem.avatar}
                        imgUrl={mem.imageAvatar ? mem.avatarURL : undefined}/>
                    </div>
                  )}
                  </div>
                </Popover>
                <CustomSwitch
                  name={"fromSharedAccount"}
                  checked={values.fromSharedAccount}
                  onChange={() =>  this.setState((prevState: any) => ({
                    values: {
                      ...prevState.values,
                      fromSharedAccount: !prevState.values.fromSharedAccount,
                    },
                  }))}
                />
                <CustomText onClick={() => this.setState((prevState: any) => ({values: {...prevState.values,fromSharedAccount: true}}))}
                  style={{backgroundColor: (values.fromSharedAccount?'white':'unset'), cursor: 'pointer',}} >
                  {tn.lang.ecoSharedAcc}
                </CustomText>
              </Col>
            </BoxedRow>
            {(this.props.uploadingFiles.length + this.props.uploadedFiles.length + this.state.previousFiles.length
              +this.state.internalDataUrl.length) > 0 &&
              <BoxedRow >
              <Col style={{flex:1, zIndex:10}}>
                <ImageList rowHeight={100} cols={3}>
                  {this.state.previousFiles.map((file, index) =>
                    <ListImage serverFile={file} key={index} zoomImage={(url:string) => this.setState({zoomImage:url})}
                      removeImage={this.removeImage}/>)}
                  {this.state.internalDataUrl.map((url:string, index:number) =>
                    <li style={{ width: '29%', height: '104px', padding: '2px', position:'relative'}} key={""+index}>
                      <AvatarEditor
                        ref={index === 0?this.editorRef1:(index === 1?this.editorRef2:(index === 2?this.editorRef3:undefined))}
                        image={url}
                        style={{ width: "70px", height: "100px", maxWidth: "70px", maxHeight: "100px" }}
                        border={0}
                        width={560}
                        height={800}
                        borderRadius={0}
                        color={[255, 255, 255, 1]}
                        scale={1}
                        rotate={0}
                        onLoadSuccess={() => this.imageLoaded(url)}
                        onLoadFailure={() => this.imageLoadFailed(url)}
                      />
                      <IconButton style={{    position: 'absolute',right: '-4px',top: '-4px',backgroundColor: styleColors.greyLight2,padding: '5px',}}
                        onClick={() => {const internalDataUrl = this.state.internalDataUrl.slice();
                          internalDataUrl.splice(index,1);
                          const loadedImageUrls = this.state.loadedImageUrls.filter(u => internalDataUrl.includes(u));
                          this.setState({internalDataUrl, loadedImageUrls})}}>
                        <DeleteIcon style={{fill:styleColors.coral800, fontSize:'18px'}} />
                      </IconButton>
                    </li>
                  )}

                  {(this.props.uploadingFiles.length + this.props.uploadedFiles.length + this.state.previousFiles.length
                    +this.state.internalDataUrl.length) < 3  &&
                  <div key={"add"} className={this.props.classes.listItemItem} style={{height: '100px', minWidth: '29%',
                    display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <label htmlFor="add-file-2" className={this.props.classes.smallAddButton} >
                      <input type="file"  multiple={false } style = {{opacity: 0, position: 'absolute', width:'50px', height:'50px'}}
                        id={"add-file-2"} onChange={this.parseFile} accept="capture=camera,image/*"/>
                      <AddIcon style={{fill:styleColors.white}} />
                    </label>
                  </div>}
                </ImageList>
              </Col>
              </BoxedRow>}
          </div>
            {this.props.existingPurchase && <BoxedRow style={{ flex: 1 }}>
              <StyledLabel htmlFor="booking" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, gap:'8px', }}>
                <span>{tn.lang.ecoTransferBooking}</span>
              </StyledLabel>
              <Col>
                <CustomSelectInverted
                  name="date"
                  value={(""+values.date)}
                  onChange={this.handleChange}
                  displayEmpty={true}
                  disableUnderline={true}
                  data={this.bookingOptions()}
                />
              </Col>
            </BoxedRow>}
        </CustomDialogContent>
        <Row style={{justifyContent: 'space-between', alignItems: 'center', padding: '10px 24px 20px'}}>
          {chatButton}
          {(this.props.existingPurchase !== undefined && !this.props.existingPurchase.deleted
            /* && this.props.existingPurchase.creator === userId */) && <IconButton onClick={() =>
            this.handleDelete()}><DeleteIcon style={{fill:styleColors.coral800}} /></IconButton>}
          <Button style={buttonContainedLarge} onClick={() => {this.cleanup(); onClose();}} color='default' variant='outlined'>
      
            {tn.lang.cancel}
       
          </Button>
          {actionButton}
        </Row>
      </Dialog>
      <Dialog
        open={(this.state.zoomImage !== undefined)}
        onClose={() => {this.setState({zoomImage:undefined});}}
        fullWidth={true}
      >
        <DialogTop >
          <Col style={{flex:1, alignItems: 'center'}}>
            <DialogTitle>{fileTitle}</DialogTitle>
          </Col>
          <IconButton onClick={() => {this.setState({zoomImage:undefined});}}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <CustomDialogContent style={{position:'relative', padding:0}}>
          <PinchZoomImage src={fileUrl} alt={fileTitle} style={{height:'auto'}}/>
          {/* <img src={fileUrl} alt={fileTitle} style={{height:'auto'}}/>  */}
        </CustomDialogContent>
        <Row style={{justifyContent: 'flex-end', padding: '20px'}}>
          <Button onClick={() => {this.setState({zoomImage:undefined});}} color='default' variant='contained' size="large">
            {tn.lang.done}
          </Button>
        </Row>
      </Dialog>
      </>
    );
  }

  private cleanup = () => {
    for (const file of this.props.uploadedFiles) {
      this.props.removeStoredFile(file.id);
    }
    for (const file of this.props.uploadingFiles) {
      this.props.removeStoredFile(file.id);
    }

  }

  private handleDelete = () => {
    if (this.props.existingPurchase !== undefined) {
      this.props.onDelete(this.props.existingPurchase.id);
    }
  }
  private getSelectedChildrenOption = (childrens: number[]):string => {
    if (childrens.length > 1) {
      return 'all';
    }
    if (childrens.length === 1) {
      return (""+childrens[0]);
    }
    return 'none';
  }

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;
    this.setState((prevState: any) => ({
      values: {
        ...prevState.values,
        [name]: newValue,
      },
    }));
  }

  private handleSliderChange = (event: any, value: number | number[]) => {
    const myPayment = convertSliderValueToPercentage( (value as number) );// value as number;
    this.updateSplit(myPayment);
  }

  private handlePercentageClick = (side: 'mine' | 'coparent') => {
    const mySplit = this.state.values.split.find((split) => split.accountId === this.props.userId);
    const myPayment = mySplit ? mySplit.percentage : 50;
    const nextMyPayment = side === 'mine'
      ? Math.min(myPayment + 1, 100)
      : Math.max(myPayment - 1, 0);

    this.updateSplit(nextMyPayment);
  }

  private updateSplit = (myPayment:number) => {
    const partnerTwoPayment = 100 - myPayment;
    const newSplit:IEcoSplit[] = [];
    for (const mem of this.props.family) {
      if (mem.id === this.props.userId) {
        newSplit.push({accountId:mem.id, percentage: myPayment});
      } else if (mem.role === FamilyMemberType.PARENT) {
        newSplit.push({accountId:mem.id, percentage: partnerTwoPayment});
      }
    }

    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        split: newSplit,
      },
    }));
  }

  private childrenDropdownData = () =>{
    const data: Array<{value:string, element:JSX.Element}> = [];
    data.push({value:"none", element:<ImgAvatar imgUrl={undefined} color="" imgName={0} style={{ width: 25, height: 25 }} 
      altText="None" grayed={true} />});
    for (const mem of this.props.family.filter((member) => member.role === FamilyMemberType.CHILD)) {
      data.push({value:(""+mem.id), element:this.getAvatar(mem, 25)});
    }
    data.push({value:"all", element:<>
      {this.props.family.filter((member) => member.role === FamilyMemberType.CHILD).slice(0,2).map((member, index) => 
        (this.getAvatar(member, 25, false, (index * -12.5))))}</>});

    return data;
  }

  private handleChildrenChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    let children: number[] = [];
    if (value === 'all') {
      children = this.props.family
        .filter((member) => member.role === FamilyMemberType.CHILD).map(member => member.id);
    } else if (value !== 'none') {
      children = [Number(value)];
    }

    this.setState((prevState: any) => ({
      values: {
        ...prevState.values,
        children,
      },
    }));
  }


  private handleSubmit = () => {

    if (this.editorRef1.current) {
      this.setState({saveClicked:true});
      this.upload(this.editorRef1.current,800,800);
    } else {
      this.save();
    }
  }

  private directSaveClose(agreement:IEcoAgreement) {

    const amount = agreement.amount;
    if (amount === undefined || amount === 0) {
      return;
    }
    
    const images:number[] = [];
    if (agreement.images !== undefined) {
      for (const i of agreement.images) {
        if (i.id !== undefined) {
          images.push(i.id);
        }
      }
    }
    
    const newTitle = agreement.repeat === EcoRepeat.ONCE
    ? agreement.title
    : agreement.repeat === EcoRepeat.WEEKLY?
      `${agreement.title} (${tn.lang.getWeekName(getWeekNum(new Date(agreement.forDate)))})`
    : agreement.repeat === EcoRepeat.MONTHLY?
      `${agreement.title} (${tn.lang.getMonthName((new Date(agreement.forDate)).getMonth())})`
    : agreement.repeat === EcoRepeat.QUARTERLY?
      `${agreement.title} (${tn.lang.getQuarterName((new Date(agreement.forDate)))})`
    : agreement.repeat === EcoRepeat.TERM?
      `${agreement.title} (${tn.lang.getTermName((new Date(agreement.forDate)))})`
    :`${agreement.title} (${(new Date(agreement.forDate)).getFullYear()})`;

    const p :INewEcoPurchase = {
      agreementId:agreement.id,
      title:newTitle,
      amount,
      currency:agreement.currency,
      description:agreement.description,
      images,
      children:agreement.children,
      split:agreement.split,
      fromSharedAccount:false,
      paidBy:this.props.userId,
      closeAgreement:true, // default is true
      startAsDisputed:false, // will cause the purchase to be disputed by other parent
    }

    this.props.onCreateNew(p);
    this.props.onClose();
  }

  private save() {
    
    const { values } = this.state;
    const { existingPurchase } = this.props;
    const images:number[] = [];

    for (const f of this.state.previousFiles) {
      if (f.id) {
        images.push(f.id);
      }
    }
    for (const f of this.props.uploadedFiles) {
      if (this.state.internalImages.includes(f.internalId)) {
        images.push(f.id);
        this.props.uploadedFileUsed(f.id);
      }
    }
    if (existingPurchase && existingPurchase.id) {
      const update:IUpdateEcoPurchase = {
        purchaseId:existingPurchase.id,
        chatId:existingPurchase.chatId,
        title:values.title,
        amount:values.amount, 
        currency:values.currency,
        description:values.description,
        paidByMe:(this.state.values.paidBy === this.props.userId), 
        images,
        children:values.children,
        split:values.split,
        fromSharedAccount:values.fromSharedAccount,
        date:values.date,
      };
      this.props.onEdit(update);
    } else {  
      this.props.onCreateNew({...this.state.values, images});
    }
  }

  private bookingOptions = () => {

    const options: Array<{
      value: string;
      element: JSX.Element;
    }> = [];

    let spin = (this.props.existingPurchase)
      ?new Date(this.props.existingPurchase.date) 
      :new Date();

    options.push({value:(""+spin.getTime()), 
    element:<>{spin.getDate()+" "+tn.lang.getMonthName(spin.getMonth()) + " "+spin.getFullYear()}</>});

    spin.setHours(12);
    spin.setMinutes(0);
    spin.setSeconds(0);
    spin.setMilliseconds(0);

    for (let index = 0; index < 50; index++) {
      const thisMonth = spin.getMonth();
      spin = addDays(spin,-1);

      options.push({value:(""+spin.getTime()), element:<>{spin.getDate()+" "+tn.lang.getMonthName(spin.getMonth())+ " "+spin.getFullYear()}</>});

    }

    return options;

  }

  private upload(editorRef:AvatarEditor, maxWidth:number, maxHeight:number) {
    const canvas = document.createElement('canvas');

    const w = editorRef.getImage().width;
    const h = editorRef.getImage().height;

    let newImgWidth = w;
    let newImgHeight = h;

    if (w >= h && w > maxWidth) {
        newImgWidth = maxWidth;
        newImgHeight = Math.floor((maxWidth * h) / w);
    } else if (h > w && h > maxHeight) {
        newImgHeight = maxHeight;
        newImgWidth = Math.floor((maxHeight * w) / h);
    }

    canvas.width = newImgWidth;
    canvas.height = newImgHeight;

    const context = canvas.getContext('2d');

    if (context !== null) {
      context.drawImage(editorRef.getImageScaledToCanvas(), 0, 0, newImgWidth, newImgHeight);
    }

    canvas.toBlob((blob) => {
      if(blob && editorRef){
        const d = handleBlobUpload(blob, "purchase.png", this.props.uploadFile);
        this.setState((prevstate) => {
          const internalImages = prevstate.internalImages.slice();
          internalImages.push(d.internalId);
          return {...prevstate, internalImages}})
      }
    })
  }

  private getAvatar(member: IFamilyMember, size: number = 30, grayed?: boolean, leftMargin?: number) {
    const image = member.avatar;
    const name = member.firstName;
    const color = member.color;
    const style: React.CSSProperties | undefined = { width: size, height: size, marginLeft: leftMargin };

    return <ImgAvatar key={member.id} color={color} imgName={image} style={style} altText={name} grayed={grayed} 
      imgUrl={member.imageAvatar?member.avatarURL:undefined}/>;
  }

  private parseFile = async (event: any) => {
    try {
      const maxSelect = 3- (this.props.uploadingFiles.length + this.props.uploadedFiles.length + this.state.previousFiles.length);
      const { files } = event.target;
      if (maxSelect > 0 && files && files.length > 0 || (event.files && event.files.length > 0)) {
        const f:File = files.item(0) ? files.item(0) : event.files.item(0);
        if (f.type && f.type.toLowerCase().includes("image")) {
          const data = await fileToBase64(f);
          const internalDataUrl = this.state.internalDataUrl.slice();
          internalDataUrl.push('data:'+f.type+';base64,'+ data);
          this.setState({internalDataUrl});
        } else if (f.type && f.type.toLowerCase().includes("video")) {
          this.props.displayErrorMessage("Videos not supported yet");
        }
      }
    } catch (error) {
      console.error("Failed to read selected purchase image", error);
      this.props.displayErrorMessage("Could not read the selected image. Please try another image.");
    }
  }


  private imageLoaded = (url:string) => {
    this.setState((prev) =>
      prev.loadedImageUrls.includes(url)
        ? prev
        : {...prev, loadedImageUrls:[...prev.loadedImageUrls, url]});
  }

  private imageLoadFailed = (url:string) => {
    this.setState((prev) => {
      const idx = prev.internalDataUrl.indexOf(url);
      if (idx === -1) {
        return prev;
      }
      const internalDataUrl = prev.internalDataUrl.slice();
      internalDataUrl.splice(idx, 1);
      const loadedImageUrls = prev.loadedImageUrls.filter(u => internalDataUrl.includes(u));
      return {...prev, internalDataUrl, loadedImageUrls};
    });
    this.props.displayErrorMessage("Could not read the selected image. Please try another image.");
  }

  private removeImage = (file:number, removeOnServer:boolean) => {
    if (removeOnServer) {
      this.props.removeStoredFile(file);
    } else {
      this.props.uploadedFileUsed(file);
    }
    this.setState({previousFiles:this.state.previousFiles.filter((f) => f.id !== file)});
  }
}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family: state.family.family,
    uploadingFiles: state.file.uploadSlots,
    uploadedFiles: state.file.uploadedFiles,
  };
}

const mapDispatchToProps = {

  uploadFile: FileActions.requestFileUpload,
  uploadedFileUsed: FileActions.uploadedFileUsed,
  removeStoredFile: FileActions.removeStoredFile,
  displayErrorMessage,
};

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(dialogStyles)(PurchaseDialog));



// WEBPACK FOOTER //
// ./src/components/economy/PurchaseDialog.tsx